export default "__VITE_ASSET__bBLSW0cr__"